function calculatePeriod(numCycles, term) {
  if (term === 12 && numCycles === 12) {
    return 'Monthly';
  }
  if (term === 12 && numCycles === 24) {
    return 'Semi - Monthly';
  }
  if (term === 12 && numCycles === 26) {
    return 'Bi - Weekly';
  }
  if (term === 12) {
    return 'Weekly';
  }

  if (term === 10 && numCycles === 10) {
    return 'Monthly';
  }
  if (term === 10 && numCycles === 20) {
    return 'Semi - Monthly';
  }
  if (term === 10 && numCycles === 22) {
    return 'Bi - Weekly';
  }
  if (term === 10) {
    return 'Weekly';
  }

  if (term === 18 && numCycles === 18) {
    return 'Monthly';
  }
  if (term === 18 && numCycles === 36) {
    return 'Semi - Monthly';
  }
  if (term === 18 && numCycles === 39) {
    return 'Bi - Weekly';
  }
  if (term === 18) {
    return 'Weekly';
  }
  return 'Weekly';
}
export default calculatePeriod;
